"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidNumber = void 0;
const lodash_1 = require("lodash");
const isValidNumber = (val) => val === '0' || !((0, lodash_1.isNil)(val) || isNaN(val) || val === '' || val === 'e');
exports.isValidNumber = isValidNumber;
